import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Heading from '../shared/Heading';
import MainButton from '../shared/MainButton';

const renderHTML = (url, vw, vh) => `
  <html>
    <head></head>
  <body style="background-color: white;">
    <div style="overflow:hidden; position:fixed; top: 0; left: 0; ">
      <img style="display: none;" src="${url}" />
    </div>
  </body>
  <script>
    let img = new Image();
    img.onload = function() {
        if(this.height < ${vh}) {
          document.querySelector('img').height = 433 * (this.height/${vh});
        } else {
          document.querySelector('img').height = 433;
        }
        document.querySelector('img').width = 578;

        document.querySelector('img').style = "display: inline; object-fit: scale-down";
    };
    img.src = "${url}";
  </script>
  </html>
`;

export default class Display extends Component {
  componentDidMount() {
    const { firstStepValid, history, previewOnly } = this.props;
    if (!firstStepValid && !previewOnly) history.push('/upload');
  }

  render() {
    const {
      contentWidth,
      contentHeight,
      signedUrl,
      title,
      html,
      fileFormat,
    } = this.props;

    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Heading>{title}</Heading>
        <BGImage url="/images/ipad.png">
          <IFrameContainer>
            <IFrame
              id="iframe"
              contentWidth={contentWidth}
              contentHeight={contentHeight}
              fileFormat={fileFormat}
              title="iframe"
              srcDoc={fileFormat === 'html' ? html : renderHTML(signedUrl, contentWidth, contentHeight)}
            />
          </IFrameContainer>
        </BGImage>
        <MainButton
          style={{ width: 700, margin: 50 }}
          onClick={() => {
            /* eslint-disable-next-line */
            document.getElementById('iframe').src = document.getElementById('iframe').src
          }}
        >
          RESTART ANIMATION
        </MainButton>
      </div>
    );
  }
}

Display.propTypes = {
  title: PropTypes.string.isRequired,
  contentWidth: PropTypes.number.isRequired,
  contentHeight: PropTypes.number.isRequired,
  firstStepValid: PropTypes.bool.isRequired,
  history: PropTypes.objectOf({
    push: PropTypes.func.isRequired,
  }).isRequired,
  signedUrl: PropTypes.string.isRequired,
  previewOnly: PropTypes.bool.isRequired,
  fileFormat: PropTypes.string.isRequired,
};

const BGImage = styled.div`
  margin: 25px;
  background-image: url('${props => props.url}');
  background-size: cover;
  width: 710px;
  height: 501px;
`;

const IFrameContainer = styled.div`
  position: absolute;
  background-color: black;
  margin-left: 66px;
  margin-top: 32px;
  width: 578px;
  height: 433px;
  overflow: hidden;
`;

const IFrame = styled.iframe`
  border: none;
  // width: 1024px;
  // height: 768px;
  width: ${props => props.fileFormat === 'html' ? `${props.contentWidth}px` : `100%`};
  height: ${props => props.fileFormat === 'html' ? `${props.contentHeight}px` : `100%`};
  // width: 100%;
  // height: 100%;
  transform: scale(${props => props.fileFormat === 'html' ? 578 / props.contentWidth : 1}, ${props => props.fileFormat === 'html' ? 433 / props.contentHeight : 1});
  transform-origin: 0 0;
`;



// WEBPACK FOOTER //
// ./client/Upload/Display.js